import 'uni-pages';
import Vue from 'vue'
import Page from './demo/pages/about/index.vue'
createPage(Page)